export enum VertexElementFormat {
  Vector2f = 0,
  Vector4f = 1,
  Int32 = 2,
  Matrix3 = 3,
}
